import React, { Fragment, Suspense, useEffect } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Redirect, Route, Switch } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { RecoilRoot } from 'recoil';
import './App.css';
import Navigation from './components/navigation';
// import NewHomePage from './pages/new-home-page';
import { loadThirdPartyScripts } from './utilities/loadThirdPartyScripts';
import ScrollTop from './utilities/scroll-top';
import ChatWidget from './components/ai-chat-assistant';
import { usePageViews } from './utilities/usePageViews';
import BusyOverlay from './components/busy-overlay';
import NewLandingPage from './pages/new-landing-page';
const NotFound = React.lazy(() => import('./pages/notfound'));
const DeleteAccount = React.lazy(() => import('./pages/delete-account'));
const About = React.lazy(() => import('./pages/about'));
const FaqArticle = React.lazy(() => import('./pages/faq-content'));
const Faq = React.lazy(() => import('./pages/faq'));
const BrokerDirectoryPage = React.lazy(
  () => import('./pages/broker-directory')
);
const ImportsPage = React.lazy(() => import('./pages/imports'));
const FrozenFoodsPage = React.lazy(() => import('./pages/frozen-foods'));
const GatewayPage = React.lazy(() => import('./pages/gateway'));
const ShopNShipPage = React.lazy(() => import('./pages/shop-n-ship'));
const ExportsPage = React.lazy(() => import('./pages/exports'));
const SeaFreightPage = React.lazy(() => import('./pages/sea-freight'));
const ResourcesPage = React.lazy(() => import('./pages/resources'));
const ChinaImports = React.lazy(() => import('./pages/china-imports'));
const ApiDocumentation = React.lazy(() => import('./pages/api-documentation'));
const NonServingCountryPage = React.lazy(
  () => import('./pages/non-serving-country')
);
const Plugin = React.lazy(() => import('./pages/plugin'));
const ShippingChecklistPage = React.lazy(
  () => import('./pages/shipping-checklist')
);
const ShippingDocumentationPage = React.lazy(
  () => import('./pages/shipping-doc')
);
const ProhibitedItemsPage = React.lazy(
  () => import('./pages/prohibited-items')
);
const Reports = React.lazy(() => import('./pages/reports'));

// Create a client
const queryClient = new QueryClient();

function App() {
  useEffect(() => {
    const domainRegExp = new RegExp('www');
    if (domainRegExp.test(window.location.origin)) {
      const domain =
        process.env.NODE_ENV === 'production'
          ? 'https://topship.africa'
          : 'http://localhost:3000';

      window.location.href = `${domain}${window.location.pathname}`;
    }

    loadThirdPartyScripts();
  }, []);
  usePageViews();
  return (
    <div className='App'>
      <QueryClientProvider client={queryClient}>
        <RecoilRoot>
          <Suspense fallback={<BusyOverlay loading={true} />}>
            <Fragment>
              <ScrollTop />
              <Navigation />
              <Switch>
                <Redirect
                  from='/:url*(/+)'
                  to={window.location.pathname.slice(0, -1)}
                />
                <Route exact path='/' component={NewLandingPage}></Route>
                {/* <Route exact path='/' component={NewHomePage}></Route> */}

                <Route exact path='/about' component={About}></Route>
                <Route exact path='/api' component={ApiDocumentation}></Route>
                <Route exact path='/plug-ins' component={Plugin}></Route>
                <Route
                  exact
                  path='/sea-freight'
                  component={SeaFreightPage}
                ></Route>

                <Route
                  exact
                  path='/faq-article/:slug'
                  component={FaqArticle}
                ></Route>
                <Route
                  path='/:sender/:receiver'
                  component={NewLandingPage}
                ></Route>

                <Route
                  path='/local-delivery'
                  component={NewLandingPage}
                ></Route>
                <Route exact path='/faqs' component={Faq}></Route>
                <Route exact path='/exports' component={ExportsPage}></Route>
                <Route exact path='/imports' component={ImportsPage}></Route>
                <Route
                  exact
                  path='/resources'
                  component={ResourcesPage}
                ></Route>
                <Route
                  exact
                  path='/broker-directory'
                  component={BrokerDirectoryPage}
                ></Route>
                <Route
                  exact
                  path='/shipping-checklist'
                  component={ShippingChecklistPage}
                ></Route>
                <Route
                  exact
                  path='/non-served-countries'
                  component={NonServingCountryPage}
                ></Route>
                <Route
                  exact
                  path='/prohibited-items'
                  component={ProhibitedItemsPage}
                ></Route>
                <Route
                  exact
                  path='/shipping-documentation'
                  component={ShippingDocumentationPage}
                ></Route>
                {/* <Route exact path='/blog' component={Blogs}></Route> */}
                <Route exact path='/gateway' component={GatewayPage}></Route>
                <Route
                  exact
                  path='/chinaimports'
                  component={ChinaImports}
                ></Route>
                <Route
                  exact
                  path='/shop-&-ship'
                  component={ShopNShipPage}
                ></Route>
                <Route
                  exact
                  path='/frozen-foods'
                  component={FrozenFoodsPage}
                ></Route>
                <Route exact path='/report' component={Reports}></Route>

                <Route
                  path='/account-delete'
                  render={props => <DeleteAccount />}
                />

                <Route
                  path='/404'
                  render={props => <NotFound heading='Page not found' />}
                />

                <Route path='/*' component={NewLandingPage}></Route>

                <Route
                  render={props => <NotFound heading='Page not found' />}
                />
              </Switch>
            </Fragment>
            <ChatWidget />
          </Suspense>
        </RecoilRoot>
      </QueryClientProvider>
      <ToastContainer />
    </div>
  );
}

export default App;
